import {
  HeapAnalyticDataProvider,
  PreBillAPIProvider,
  PreBillProvider,
  PreBillHeapProvider,
} from "@app/provider";
import React, { ReactNode } from "react";

interface PreBillContextWrapperProps {
  children: ReactNode;
}

export const PreBillContextWrapper: React.FC<PreBillContextWrapperProps> = ({
  children,
}) => {
  return (
    <PreBillProvider>
      <HeapAnalyticDataProvider>
        <PreBillAPIProvider>
          <PreBillHeapProvider>{children}</PreBillHeapProvider>
        </PreBillAPIProvider>
      </HeapAnalyticDataProvider>
    </PreBillProvider>
  );
};
